import angular from 'angular';

let fileReader = angular.module('fileReader', [])
						 .factory('fileReader', ($q) => {
							 'ngInject';
							 const onLoad = function(reader, deferred, scope) {
								 return function() {
									 scope.$apply(function() {
										 deferred.resolve(reader.result);
									 });
								 };
							 };

							 const onError = function(reader, deferred, scope) {
								 return function() {
									 scope.$apply(function() {
										 deferred.reject(reader.result);
									 });
								 };
							 };

							 const getReader = function(deferred, scope) {
								 let reader = new FileReader();
								 reader.onload = onLoad(reader, deferred, scope);
								 reader.onerror = onError(reader, deferred, scope);
								 return reader;
							 };

							 const readAsDataURL = function(file, scope) {
								 let deferred = $q.defer();

								 let reader = getReader(deferred, scope);
								 reader.readAsDataURL(file);

								 return deferred.promise;
							 };

							 return {
								 readAsDataUrl: readAsDataURL
							 };
						 }).name;

export default fileReader;



// WEBPACK FOOTER //
// ./client/app/services/fileReader.service.js